import { ActivityRecordPdf } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';

type Props = {
  /** PDFの1つのアイテム。 */
  pdf: ActivityRecordPdf;
};

/** PDFの1つのアイテムコンポーネント。 */
export const PdfItem = ({ pdf }: Props) => {
  const handleClick = () => {
    // pre_signed_urlが存在しない場合のエラーハンドリング
    if (!pdf.preSignedUrl) {
      alert('PDFのURLが取得できませんでした。ページを再読み込みして再度お試しください。');
      return;
    }

    try {
      window.open(pdf.preSignedUrl, '_blank', 'noopener,noreferrer');
    } catch (error) {
      alert('PDFを開く際にエラーが発生しました。URLの有効期限が切れている可能性があります。ページを再読み込みして再度お試しください。');
    }
  };

  return (
    <button
      key={pdf.documentId}
      onClick={handleClick}
      className="inline-flex items-center gap-[8px] text-left"
    >
      <ArrowTopRightOnSquareIcon />
      <p className="text-[16px] noto-sans-jp-medium text-primary underline">
        {pdf.fileName}
      </p>
    </button>
  );
};

const ArrowTopRightOnSquareIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.2"
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
        stroke="#26409E"
      />
    </svg>
  );
};
